module.exports = __webpack_public_path__ + "static/media/video2-woodridge.b31fc4fe.mp4";